export default "__VITE_ASSET__BAxM_Dbj__"